import { Center, Text } from '@chakra-ui/react';
import { ChainNetwork } from '@cronos-app/sdk';
import { useDesiredNetwork, useGlobalContextStore } from '@cronos-app/wallet';

/**
 * experimental feature
 * @returns
 */
export const GlobalChainSelect = () => {
  const desiredNetwork = useDesiredNetwork();

  return (
    <Center
      fontWeight="bold"
      color="white"
      cursor="pointer"
      rounded="4px"
      bgColor="rgba(23, 24, 26, 0.75)"
      onClick={(e) => {
        useGlobalContextStore.setState({
          chainNetwork:
            desiredNetwork === ChainNetwork.mainnet
              ? ChainNetwork.testnet
              : ChainNetwork.mainnet,
        });
        e.stopPropagation();
      }}
    >
      <Text>
        {desiredNetwork === ChainNetwork.mainnet ? 'Mainnet' : 'Testnet'}
      </Text>
    </Center>
  );
};
